<script lang="ts">
import { storeToRefs } from "pinia"
import customTablePageInit from "../../utils/customTablePageInit.vue"
import { useEpciCommuneStore } from "../../store"

export default {
    name: "ListUsers",
    extends: customTablePageInit,
    setup() {
        useHead({
            title: "Larchiviste | Utilisateurs",
            meta: [
                { name: "description", content: "Gestion des utilisateurs" },
            ],
        })
        definePageMeta({
            middleware: ["auth"],
        })
        const epciCommuneStore = useEpciCommuneStore()
        const { currentEpciCommune } = storeToRefs(epciCommuneStore)
        // Define `customQuery` as a computed property
        const customQuery = computed(() => {
            return currentEpciCommune.value?.id
                ? { customQueryKey: "epci_commune_id", queryId: currentEpciCommune.value.id }
                : null
        })
        const accessToken = useCookie("access_token")
        const adminOriginalToken = useCookie("admin_original_token")
        return {
            currentEpciCommune,
            customQuery,
            accessToken,
            adminOriginalToken,
            epciCommuneStore,
        }
    },
    data() {
        const columns = [
            { dataKey: "role", transform: [this.toTranslate], template: [this.isChips] },
            { dataKey: "function" },
            { dataKey: "email" },
            { dataKey: "first_name" },
            { dataKey: "last_name" },
            { dataKey: "delete", transform: [this.toTranslate], template: [this.isChips] },
        ]

        if (!this.currentEpciCommune?.id || this.currentEpciCommune?.accessible_communes?.length) {
            columns.unshift({ dataKey: "epci_commune.v" })
        }
        return {
            permissionName: "user",
            requestName: "users",
            defaultUrl: "/utilisateurs",
            translationName: "utilisateurs",
            columns,
            initSort: {
                // key : "name",
                // order : "asc"
            },
            filtersOverload: [
                "epci_commune_id",
                "role",
                "function",
                "email",
                "first_name",
                "last_name",
                "deleted",
            ],
        }
    },
    watch: {
        // Watch for changes in currentEpciCommune and call loadData
        currentEpciCommune: {
            immediate: true,
            deep: true, // In case currentEpciCommune is an object and not a primitive
            handler(newValue, oldValue) {
                if (newValue?.id !== oldValue?.id && oldValue !== undefined) {
                    this.loadData()
                }
            },
        },
    },
    mounted() {
        this.loading = true
    },
    methods: {
        async impersonateUser(userId) {
            try {
                const response = await this.$api.setRequest({
                    url: `users/${userId}/impersonate`,
                    method: "POST",
                })

                if (this.accessToken) {
                    this.adminOriginalToken = this.accessToken
                }

                this.accessToken = response.token

                window.location.href = "/"
            }
            catch (error) {
                // Gestion d'erreur via le toaster global (à adapter selon ton projet)
                if (this.$toaster) {
                    this.$toaster.error("Impossible de prendre l'identité de cet utilisateur.")
                }
                else {
                    console.error("Erreur d'impersonation :", error)
                }
            }
        },
        // setGlobalName(key, value, template, item) {
        //     console.log('item', item)
        //     let html = template
        //     if (item.last_name) {
        //         // html += `<div class='text-caption'><v-icon class="mr-2" size="small">mdi-phone</v-icon>${item.declarant.mobile}</div>`
        //         html += ` ${item.last_name}`
        //     }
        //     return html
        // },
    },
}
</script>

<template>
    <div id="utilisateurs">
        <ListActionsButtons
            :query="$refs?.filters?.query"
            :request-name
            :translation-name
            :exportable
            :default-url
            :permission-name
            class-override=""
        />
        <ListFilters
            v-if="filters"
            ref="filters"
            :permission-name
            :filters
            :translation-name
            :filters-overload
            class-override="filters mb-3"
            @load-data="loadData()"
            @reset-pagination="$refs.pagination.resetPagination()"
        />
        <v-card class="pa-5">
            <ListTable
                ref="table"
                :value-as-view-link="[]"
                :permission-name
                :translation-name
                :columns
                :sortable
                :default-url
                :loading
                :data
                :init-sort
                @reset-pagination="$refs.pagination.resetPagination()"
                @load-data="loadData()"
                @delete-data="deleteData($event)"
            >
                <template #optionsList="{ item }">
                    <v-list-item
                        v-if="item.role !== 'admin' && $currentUser()?.role === 'admin'"
                        density="compact"
                        class="link-as-list-item"
                        @click.prevent.stop="impersonateUser(item.id)"
                    >
                        <v-list-item-title class="text-caption text-warning">
                            <v-icon
                                icon="mdi-incognito"
                                size="small"
                                class="mr-2"
                                color="warning"
                            />
                            Se connecter en tant que
                        </v-list-item-title>
                    </v-list-item>
                </template>
            </ListTable>
            <div>
                <ListPagination
                    ref="pagination"
                    :total
                    :loading
                    :last-page
                    @load-data="loadData"
                />
            </div>
        </v-card>
    </div>
</template>
